import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import DatePicker from '@/components/forms/new/formikFormFields/DatePicker';

const ApprovalCodeValidTo = ({ errors, touched, darkMode, validToTime, setValidToTime }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;

    // Set default date to 14 days from today if not already set
    const defaultValidTo = new Date();
    defaultValidTo.setDate(defaultValidTo.getDate() + 14);

    return (
        <FormControl
            isInvalid={!!errors.validTo && touched.validTo}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Approval Code Expiry Date
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the expiry date for this approval code.
                    </Text>
                </Box>
                <Box flex="1">
                    <Field name="validTo">
                        {({ field, form }) => {
                            console.log(form.values.validTo, validToTime, defaultValidTo);  
                            // Use form value, then validToTime, then default (14 days from now)
                            const dateValue = form.values.validTo
                                ? new Date(form.values.validTo)
                                : validToTime || defaultValidTo;

                            return (
                                <DatePicker
                                    field={field}
                                    form={form}
                                    darkMode={darkMode}
                                    date={dateValue}
                                    changeHandler={(_, value) => {
                                        form.setFieldValue('validTo', value.toISOString().replace(/\.\d{3}Z$/, '.000Z'));
                                        
                                        setValidToTime(value);
                                    }}
                                    walkthroughid={createMode.ufApprovalExpiryDate}
                                    isLoading={form.isSubmitting}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the expiry date for this approval code."
                        ariaLabel="approval-code-validto-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodeValidTo;